export function getEpisodeNumber(episodeId, podcastName) {
    const value = String(episodeId ?? '');
    const prefix = podcastName ? `${podcastName}_` : '';

    if (prefix && value.startsWith(prefix)) {
        return value.slice(prefix.length);
    }

    const separatorIndex = value.lastIndexOf('_');
    if (separatorIndex !== -1 && separatorIndex < value.length - 1) {
        return value.slice(separatorIndex + 1);
    }

    return value;
}

export function getEpisodeNumberSortValue(episodeId, podcastName) {
    const episodeNumber = getEpisodeNumber(episodeId, podcastName);

    if (!/^\d/.test(episodeNumber)) {
        return null;
    }

    const numericValue = parseInt(episodeNumber, 10);

    return Number.isFinite(numericValue) ? numericValue : null;
}

export function compareEpisodeNumbersDescending(aEpisodeId, bEpisodeId, podcastName) {
    const aNumber = getEpisodeNumber(aEpisodeId, podcastName);
    const bNumber = getEpisodeNumber(bEpisodeId, podcastName);
    const aNumeric = getEpisodeNumberSortValue(aEpisodeId, podcastName);
    const bNumeric = getEpisodeNumberSortValue(bEpisodeId, podcastName);

    if (aNumeric !== null && bNumeric !== null && aNumeric !== bNumeric) {
        return bNumeric - aNumeric;
    }

    if (aNumeric !== null && bNumeric === null) {
        return -1;
    }

    if (aNumeric === null && bNumeric !== null) {
        return 1;
    }

    return bNumber.localeCompare(aNumber, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
}

export function sortEpisodesByEpisodeNumberDesc(episodes, podcastName) {
    return [...(episodes || [])].sort((a, b) => (
        compareEpisodeNumbersDescending(a.id, b.id, podcastName)
    ));
}
